import { ButtonLoader, Input } from 'components/__new/common/form'
import { REGEX_VALUES } from 'utils/regexValues'
import SignupFormHeader from './SignupFormHeader'
import AccountExistsButton from './AccountExistsButton'
import { ReactComponent as NigFlag } from "assets/images/icons/project-icons/nig-flag.svg";


const GetStartedPersonalInfo = ({form, updateForm, formErrors, submitForm}) => {
    
    const submitDisabled = (!form?.firstName?.length || formErrors?.firstName?.includes("Invalid"))
                            || (!form?.lastName?.length || formErrors?.lastName?.includes("Invalid"))
                            || (!form?.email?.length || formErrors?.email?.includes("Invalid"))
                            || !REGEX_VALUES.EMAIL.test(form?.email)
                            || (!form?.phoneNumber?.length || formErrors?.phoneNumber?.includes("Invalid"))
                            || form?.phoneNumber?.length !== 11;
    
    return (
        <div>
            
            <SignupFormHeader 
                stepCount="1"
                headerText="Let's get you started"
                completionPercentage={50}
            />
            
            <form onSubmit={submitForm}>
                <div className="mt-10 w-full max-w-md mx-auto md:mx-0 lg:w-96">
                    
                    <Input
                        type="text" 
                        label="First Name"
                        value={form.firstName} 
                        placeholder="Enter first name" 
                        tagText={formErrors?.firstName}
                        tagTextIsRed
                        onChange={(e) => updateForm(e, "firstName", REGEX_VALUES.LETTERS_WITH_HYPHEN)} 
                    />
                    
                    <Input 
                        type="text" 
                        label="Last Name"
                        value={form.lastName} 
                        placeholder="Enter last name" 
                        tagText={formErrors?.lastName}
                        tagTextIsRed
                        onChange={(e) => updateForm(e, "lastName", REGEX_VALUES.LETTERS_WITH_HYPHEN)} 
                    />
                    
                    <Input 
                        type="text" 
                        label="Email Address"
                        value={form.email} 
                        placeholder="Enter email address" 
                        tagText={formErrors?.email}
                        tagTextIsRed
                        onChange={(e) => updateForm(e, "email", REGEX_VALUES.EMAIL)} 
                    />
                    
                    <div className="form-group relative">
                        <label>
                            Phone Number
                        </label>
                        <input
                            type="number"
                            id="prl-input"
                            className="form-input"
                            value={form.phoneNumber}
                            style={{paddingLeft: "30px"}}
                            placeholder="Enter phone number"
                            onChange={(e) => {
                                if (e.target.value.length > 11) return;
                                updateForm(e, "phoneNumber", REGEX_VALUES.PHONE_NUMBER)
                            }}
                        />
                        
                        <div className="absolute left-2 top-8 flex items-center">
                            <NigFlag />
                            {/* <div className="text-xs">&nbsp;+234</div> */}
                        </div>
                        <span className={`text-xs transition-opacity duration-500 ${formErrors?.phoneNumber?.length ? "opacity-100" : "opacity-0"} text-ep-danger-200`}>
                            Invalid phone number
                        </span>
                    </div>

                    <ButtonLoader disabled={submitDisabled} type="submit" className="btn btn-lg btn-block btn-ep-primary mt-8 disabled:!bg-[#E2E8F0] disabled:cursor-not-allowed transition-colors duration-300">
                        Continue
                    </ButtonLoader>

                    <AccountExistsButton />
                </div>
            </form>
        </div>
    )
}

export default GetStartedPersonalInfo